import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusesTotalValue } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-canvas" data-id="element-28" data-mp="22f3dzf1jrfnk">
      <div className="max-w-5xl mx-auto" data-id="element-29" data-mp="1yeb4ckorj8qr">
        <div className="text-center mb-16" data-id="element-30" data-mp="1yfcr3mf55job">
          <p className="text-gold font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-31" data-mp="1aogso6g6jq83">
            Included free with your system
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white" data-id="element-32" data-mp="15qf9zmmo1sx5">
            5 complete <span className="text-gold" data-id="element-33" data-mp="1jhsrkv10kgpj">bonus guides</span>
          </h2>
          <p className="text-mist mt-4" data-id="element-34" data-mp="1eqaq85v2we41">
            Even more options — without repeating the main 6-volume system.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-35" data-mp="qywxvzwxgij2">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-card border border-line rounded-2xl p-8 relative flex flex-col" data-id="element-36" data-mp="myczkt0mb8vc" data-mpi={index}>
              <div className="absolute top-0 right-0 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm bg-gold text-canvas" data-id="element-37" data-mp="2ofo577dfhmik">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 border border-gold/40 rounded-full flex items-center justify-center mb-6 text-gold" data-id="element-38" data-mp="1vtd47vlwtjl8">
                <Gift size={22} aria-hidden="true" data-id="element-39" data-mp="20ptv2xkhuc20" />
              </div>
              <h3 className="text-xl font-display font-bold mb-3 pr-24 text-white" data-id="element-40" data-mp="25rj4y9vzcjoi">{bonus.title}</h3>
              <div className="inline-flex items-center gap-2 mb-4 self-start" data-id="element-41" data-mp="3c5ighki3n30p">
                <span className="text-steel text-sm" data-id="element-42" data-mp="3h553glnqbxmp">
                  Real value: <span className="line-through" data-id="element-43" data-mp="3h7hjgt9xfxx4">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold" data-id="element-44" data-mp="1h5hz2s44k0jc">→ FREE</span>
              </div>
              <p className="text-mist text-sm mb-6 leading-relaxed flex-grow" data-id="element-45" data-mp="1c42fz5lic43l">{bonus.desc}</p>
              <p className="text-white text-sm font-display font-semibold tracking-wide mt-auto" data-id="element-46" data-mp="1q3jyj387ml4i">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-black border border-gold/60 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-47" data-mp="ydfe54kg9y3a">
          <p className="text-mist mb-2" data-id="element-48" data-mp="12co8aajejxzd">Total value of the 5 bonus guides</p>
          <p className="text-2xl text-steel line-through mb-4" data-id="element-49" data-mp="en3qhuyzj6ro">{bonusesTotalValue}</p>
          <p className="text-lg text-white mb-2" data-id="element-50" data-mp="amtkiib70gct">Your price today</p>
          <p className="text-5xl font-display font-bold text-gold mb-4" data-id="element-51" data-mp="j4pc4prvcki">FREE</p>
          <p className="text-sm text-steel" data-id="element-52" data-mp="59uv3j241hfq">Included with Boxing Coach Ready.</p>
        </motion.div>
        <CountdownTimer data-id="element-53" data-mp="3mquwska1crwd" />
      </div>
    </section>;
}